import axios from 'axios'

// 设置超时
axios.defaults.timeout = 600000

export default axios



// WEBPACK FOOTER //
// ./src/common/utils/http.js